// State constants
export const States = {
  SCRAPED: 'SCRAPED',
  CLASSIFIED: 'CLASSIFIED',
  CLASSIFICATION_FAILED: 'CLASSIFICATION_FAILED',
  NOT_RECOGNIZED: 'NOT_RECOGNIZED',
  DOWNLOAD_FAILED: 'DOWNLOAD_FAILED',
  ERROR: 'ERROR',
  INVALID_SCORE: 'INVALID_SCORE',
  EDITING: 'EDITING',
  AUTO_APPROVED: 'AUTO_APPROVED',
  MANUALLY_APPROVED: 'MANUALLY_APPROVED',
  PUSHED: 'PUSHED',
}

// Event constants
export const Events = {
  EDIT: 'EDIT',
  INVALIDATE: 'INVALIDATE',
  MANUALLY_APPROVE: 'MANUALLY_APPROVE',
  GO_BACK: 'GO_BACK',
  RESET: 'RESET',
}

export const Tags = {
  ERROR: 'error',
  EDITABLE: 'editable',
  FINAL: 'final',
  APPROVABLE: 'approvable',
  APPROVED: 'approved',
  VALID: 'valid',
}
